/** A label / value line of the mission detail. */
const MissionDetailRow = ({ label, children }) => (
  <div className={'flex gap-1'}>
    <div className={'w-1/2 font-medium'}>{label}</div>
    <div className={'w-1/2 text-gray-700'}>{children}</div>
  </div>
);

export default MissionDetailRow;
